var _path, _path2, _path3, _ellipse, _ellipse2, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 160",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.7,37.8l-0.3,0l-0.3,0.1c-0.1,0-12,2.9-23.5,1.9c-11.5-1-22.8-5.9-23-5.9l-0.3-0.1l-0.2,0c0.1,1.4,0.2,2.9,0.3,4.4  c3.5,1.4,12.9,4.8,22.8,5.7c11.2,1,22.3-1.4,24.5-1.9c3.2,0.4,5.5,3.3,5.3,6.5c0,0.1-1,14.5-2.4,25.8c-2.8,21.5-19.1,40.6-33.5,39.3  c-11.9-1-22.8-16.1-25.6-33.5c-1,1.6-2.1,3.1-3.2,4.5c3.9,17.6,15.6,31.9,28.5,33c0.6,0.1,1.1,0.1,1.7,0.1  c16.2,0,33.1-19.8,36.1-42.9c1.5-11.4,2.4-25.9,2.5-26C128.3,43.1,124.2,38.2,118.7,37.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7,44.6C67.2,32.7,65.6,18,65.6,18c-0.5-4.5-4.6-7.8-9.1-7.4c0,0-11.8,5.2-24.1,6.2c-12.3,1.1-24.9-1.9-24.9-1.9  c-4.5,0.4-7.9,4.4-7.6,8.9c0,0,1.1,15.8,2.4,26.6c2.8,23.5,21,43.5,36.6,42.1C54.6,91,68.8,68.3,67.7,44.6z M13.7,42.9  c-0.2-2.5,2.7-4.8,6.6-5.1c3.9-0.3,7.1,1.4,7.4,3.9c0.2,2.5-2.7,4.8-6.6,5.1S13.9,45.4,13.7,42.9z M37.7,76.5  c-7.6,0.7-17.4-3.6-18.2-13.5c0,0,4.4,6.6,17.5,5.5C50.1,67.3,53.3,60,53.3,60C54.2,69.9,45.3,75.8,37.7,76.5z M48.9,44.4  c-3.9,0.3-7.1-1.4-7.4-3.9s2.7-4.8,6.6-5.1c3.9-0.3,7.1,1.4,7.4,3.9S52.8,44,48.9,44.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,94.7c0,0,4.2-6.3,16.5-5.2c12.4,1.1,15.4,8,15.4,8c0.8-9.3-7.6-14.9-14.7-15.5C83.9,81.4,74.6,85.4,73.8,94.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.719920e-02 -0.9962 0.9962 8.719920e-02 8.5913 137.2214)",
    cx: 79.2,
    cy: 63.9,
    rx: 4.3,
    ry: 6.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.709996e-02 -0.9962 0.9962 8.709996e-02 30.601 165.9122)",
    cx: 105.8,
    cy: 66.3,
    rx: 4.3,
    ry: 6.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 143,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by purplestudio")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 148,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActorIcon);
export default __webpack_public_path__ + "static/media/actorIcon.d7abb9380f12ac7cc6ff97ee0cbb1b42.svg";
export { ForwardRef as ReactComponent };